import Vue from 'vue';
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $utils from "@/lib/utils/index.js";

const ifilNftTradeContract = require('./ifilNftTradeContract.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.ifilNftTradeContractAddressV2;
let contractName = $bizConfig.ifilNftV2TradeName;
let contractSalt = $bizConfig.ifilNftV2TradeSalt;
let contractVersion = $bizConfig.ifilNftV2TradeVersion;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(ifilNftTradeContract.abi, contractAddress) : '',
}

const getIfilNftTradeAddressV2 = () => {
    return contractAddress;
}

const getIfilNftTradeContractV2 = () => {
    return contractConst.contract;
}

const getIfilNftTradeNameV2 = () => {
    return contractName;
}

const getIfilNftTradeVersionV2 = () => {
    return contractVersion;
}

const getIfilNftTradeSaltV2 = () => {
    return contractSalt;
}

const tradeNFTV2 = ([makerData], options, callback) => {
    return $web3js.send(getIfilNftTradeContractV2().methods.tradeNFT, [makerData], options, callback);
}

const tradeNFTEstimateSendV2 = async([makerData], options) => {
    let gasPromise = $web3js.estimateSend(getIfilNftTradeContractV2().methods.tradeNFT, [makerData], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const tradeNFTV3 = ([_miner, makerData], options, callback) => {
    return $web3js.send(getIfilNftTradeContractV2().methods.tradeNFT, [_miner, makerData], options, callback);
    //return $web3js.send(getIfilNftTradeContractV2().methods.tradeNFT, [makerData], options, callback);
}

const tradeNFTEstimateSendV3 = async([_miner, makerData], options) => {
    console.log(_miner)
    console.log(makerData)
    let gasPromise = $web3js.estimateSend(getIfilNftTradeContractV2().methods.tradeNFT, [_miner, makerData], options);
    //let gasPromise = $web3js.estimateSend(getIfilNftTradeContractV2().methods.tradeNFT, [makerData], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

export default {
    getIfilNftTradeAddressV2,
    getIfilNftTradeContractV2,
    getIfilNftTradeNameV2,
    getIfilNftTradeVersionV2,
    getIfilNftTradeSaltV2,
    tradeNFTV2,
    tradeNFTEstimateSendV2,
    tradeNFTV3,
    tradeNFTEstimateSendV3,
}


// WEBPACK FOOTER //
// ./src/lib/contract/ifilNftTradeV2/index.js